import {useEffect} from 'react'

import {useSelector, onlyIfForm} from '../../store.js'
import {
  stocktakeListFormSelector,
  stocktakeListQuerySelector,
} from './stocktakeListFunctions.js'
import {hasStocktakeFeatureSelector} from '../../data/stocktakes.js'
import Modals from './Modals/index.js'
import StocktakeListItemsCount from './StocktakeListItemsCount.js'
import RefreshStocktakeList from './RefreshStocktakeList.js'
import StocktakeExpandAll from './StocktakeExpandAll.js'
import StocktakeSort from './StocktakeSort.js'
import Actions from './Actions.js'
import ActionsForSelected from './ActionsForSelected.js'
import List from './List.js'
import StocktakeListOmniBar from './StocktakeListOmniBar.js'
import StocktakeFeaturePage from './StocktakeFeaturePage.js'
import {hasStocktakePermissionSelector} from '../../data/me.js'
import NoPermissionsPage from '../NoPermissionsPage.js'
import {showStocktakeListFilterModal} from './Modals/StocktakeListFilterModal/stocktakeListFilterModalFunctions.js'
import FiltersButton from '../../common/components/FiltersButton.js'

function StocktakeListPage({form}) {
  useEffect(() => {
    document.title = 'Stocktakes'
  }, [])

  const hasStocktakeFeature = useSelector(hasStocktakeFeatureSelector)
  const hasStocktakePermission = useSelector(hasStocktakePermissionSelector)
  const query = useSelector(stocktakeListQuerySelector)

  if (!hasStocktakeFeature) {
    return <StocktakeFeaturePage />
  }

  if (!hasStocktakePermission) {
    return <NoPermissionsPage />
  }

  return (
    <div id="iverson-page">
      <Modals />
      <div className="wrap--container">
        <div className="wrap--row">
          <div className="medium-12 columns">
            <div className="wrap--list-header flex--justify padding-top-10 padding-bottom-10">
              <ul className="list list--no-style">
                <StocktakeListItemsCount />
                <RefreshStocktakeList />
                <StocktakeExpandAll />
                <li className="inline-block divider--left">
                  <FiltersButton
                    onClick={() => showStocktakeListFilterModal({query})}
                  />
                </li>
                <StocktakeSort />
                {form.selectedReferenceIDs.length ? (
                  <ActionsForSelected
                    referenceIDs={form.selectedReferenceIDs}
                  />
                ) : (
                  <Actions />
                )}
              </ul>
            </div>
          </div>
        </div>
        <div className="wrap--row">
          <div className="medium-12 columns">
            <StocktakeListOmniBar />
          </div>
        </div>
        <div className="wrap--row margin-top-10">
          <List />
        </div>
      </div>
    </div>
  )
}

export default onlyIfForm(StocktakeListPage, stocktakeListFormSelector)
